// extracted by mini-css-extract-plugin
export default {"declinedContainer":"DeclinedApplication_declinedContainer","link":"DeclinedApplication_link","redirectButton":"DeclinedApplication_redirectButton"};